import { render, staticRenderFns } from "./invoiceDetail.vue?vue&type=template&id=2b657e5f&scoped=true&"
import script from "./invoiceDetail.vue?vue&type=script&lang=js&"
export * from "./invoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetail.vue?vue&type=style&index=0&id=2b657e5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b657e5f",
  null
  
)

export default component.exports